export const VerticalDivider = () => {
  return <div className="h-7 w-0 border border-grey" />;
};
